
import { COPY } from './copy'
import { bookingGates, eligiblePeople, personName } from './logic'

export default {
    props: {
        state: { type: Object, required: true },
        advisorLabel: { type: String, default: COPY.rail.noPreference },
        booking: { type: Boolean, default: false },
        // #727: the Referred by row; null hides it (not an Other-source client).
        referredBy: { type: String, default: null },
        // #727: the open states, so Book applies the who-referred gate.
        openStates: { type: Array, default: () => [] },
    },
    data () {
        return { COPY }
    },
    computed: {
        schedule () { return this.state.schedule },
        clientNames () {
            return eligiblePeople(this.state).map(personName).join(' & ')
        },
        whenLabel () {
            if (this.schedule.method === 'email') return COPY.rail.whenEmail
            if (!this.schedule.date || !this.schedule.time) return COPY.rail.whenPending
            const m = this.$moment.tz
                ? this.$moment.tz(this.schedule.time, this.schedule.timezone)
                : this.$moment(this.schedule.time)
            return `${m.format('dddd, MMMM D')} · ${m.format('h:mm A')} ${m.format('z')}`
        },
        methodLabel () {
            const m = this.schedule.method
            if (m === 'phone') return COPY.rail.phone
            if (m === 'video') return COPY.rail.video
            if (m === 'email') return 'Email'
            return '-' // no method selected yet (no default)
        },
        statusRows () {
            const rows = eligiblePeople(this.state).map((p) => {
                if (p.soa.captured) {
                    return { name: personName(p), chip: COPY.rail.chipSoa(this.$moment(p.soa.captured_at).format('h:mm A')), cls: 'confirmed' }
                }
                if (p.soa.absent) {
                    return { name: personName(p), chip: COPY.rail.chipAdvisorCapture, cls: 'absent' }
                }
                return { name: personName(p), chip: COPY.rail.chipPending, cls: 'pending' }
            })
            // Strict false: an unanswered guidance pill (null) must not read
            // as "Sitting in · no SOA needed" — those attendees stay off the
            // list until answered (the attendee_status gate blocks booking).
            this.state.attendees.filter(a => a.guidance === false).forEach((a) => {
                rows.push({ name: personName(a), chip: COPY.rail.chipSittingIn, cls: 'sitting' })
            })
            return rows
        },
        absentCount () {
            return eligiblePeople(this.state).filter(p => p.soa.absent).length
        },
        closingScript () {
            if (this.schedule.method === 'email') return COPY.rail.closingEmail
            if (!this.schedule.date || !this.schedule.time) return ''
            const m = this.$moment.tz
                ? this.$moment.tz(this.schedule.time, this.schedule.timezone)
                : this.$moment(this.schedule.time)
            return COPY.rail.closingCall(m.format('dddd, MMMM D'), m.format('h:mm A'), this.schedule.method === 'video')
        },
    },
    methods: {
        onBook () {
            const gates = bookingGates(this.state, { aepSeason: !!this.$store?.getters?.isAEPScheduling, openStates: this.openStates })
            if (gates.length) {
                this.$emit('blocked', gates)
                return
            }
            this.$emit('book')
        },
    },
}
